const styles = () => {
  return {
    dropUploader: {
      height: '42.5px',
      borderRadius: '4px',
      border: 'solid 1px #e2e5ec',
      lineHeight: '36px',
      cursor: 'pointer',
      '&:focus': {
        outline: 'none',
      },
    },
    error: {
      border: '1px solid #FF0000',
    },
    metaInfo: {
      fontSize: '11px',
      color: '#808080',
      marginTop: '8px',
    },
    contentText: {
      width: '60%',
      display: 'inline-block',
      verticalAlign: 'middle',
      color: '#808080',
      fontSize: '14px',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
    },
    uploadIcon: {
      marginRight: '12px',
      textAlign: 'center',
      width: '46px',
      height: '100%',
      display: 'inline-block',
      margin: 'auto',
      background: '#f7f8fa',
      borderRadius: '4px 0 0px 4px',
      borderRight: 'solid 1px #e2e5ec',
    },
    fileDetails: {
      marginTop: '5px',
    },
    fileName: {
      color: '#808080',
      wordBreak: 'break-all',
      fontSize: '12px',
    },
    fileError: {
      fontSize: '9px',
      color: '#FF0000',
    },
    selectFileText: {
      borderBottom: '1px #f8bf45 solid',
    },
    crossIcon: {
      paddingRight: '14px',
      float: 'right',
    },
  };
};

export default styles;
